export const main = {
    loading: 'Chargement de vos informations…',
    cancel: {
        action: "perdre vos modifications", 
        'message-details': "Vous êtes sur le point d'annuler l'ensemble de vos modifications :<ul><li>{details}</li></ul>Vous confirmez ?",
        message: "Vous êtes sur le point d'annuler l'ensemble de vos modifications. Vous confirmez ?",
        title: "Annulation", 
    },
    'create-by': "Créé par",
}